













































import {
  MessageType,
  SystemSendMessageType,
} from "@/resources/constants/graphicClient/graphicClient";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import Loader from "@/resources/mixins/loader/loader";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import { i18n } from "@/resources/locales";
@Component({
  name: "super-spaces-component",
})
export default class SuperSpacesComponent extends mixins(
  NotificationEvent,
  Loader
) {
  @Prop() superSpace;
  loading = false;
  get superSpaces() {
    return this.$store.getters["SuperSpaceStore/getSuperSpaces"];
  }
  async focusSuperSpace(superSpace): Promise<void> {
    /*if (
      superSpace.usersConnected != 0 &&
      superSpace.usersConnected >= superSpace.usersConnectedLimit
    ) {
      this.onWarning("", i18n.t("notifications.descriptions.spaceFull"));
      return;
    }*/
    this.startLoader(this.$store);
    await this.$store.dispatch("SpaceStore/setSpacesAvailablePageAction", 1);
    await this.$store.dispatch("SpaceStore/setLastPageSpacesAction", 2);
    await this.$store.dispatch("SpaceStore/getSpacePaginateAction", {
      id: superSpace.id,
      callback: (response) => {
        this.$store.dispatch(
          "SystemStore/setSelecSuperSpaceIdAction",
          superSpace.id
        );
        this.$store.dispatch("SystemStore/setOpenChangeSpaceModalAction", true);
      },
      callbackError: (error) => {
        // do nothing
      },
    });
  }
  addFavourite(isFavourite: boolean): void {
    const tooltip = document.getElementsByClassName("vs-tooltip");
    if (tooltip)
      while (tooltip.length > 0) {
        tooltip[0].parentNode.removeChild(tooltip[0]);
      }
    if (this.loading) return;
    this.loading = true;
    this.$store.dispatch("SuperSpaceStore/addFavouriteAction", {
      id: this.superSpace.id,
      data: {
        isFavourite: !isFavourite,
      },
      callback: (response) => {
        /*  const favourites = document.getElementsByClassName("favouriteStart");
        const data = {
          id: this.superSpace.id,
          isFavourite: response.data.isFavourite,
        }; */
        /* GraphicClient.sendMessage(
          MessageType.SYSTEM,
          SystemSendMessageType.UPDATE_PIN,
          data
        ); */
        this.loading = false;
      },
      callbackError: (error) => {
        this.onError(
          this.$i18n.t("notifications.titles.error"),
          this.$i18n.t("notifications.genericError.genericErrorRetry"),
          "none"
        );
      },
    });
  }
}
